import React from "react";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";

export default function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link
        color="inherit"
        href="https://fcarbon.org/"
        target="_blank"
      >
        fcarbon.org
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
      {/* 
      <div class="copyright">
        Developed by <a href="https://fcarbon.org/" target="_blank">Bioinformatica Labs</a>
      </div> */}
    </Typography>
  );
}
